export const hireMernStackPageContentArabic = {
  // محتوى Helmet 
  helmet: {
    title: "وظّف مطوري MERN Stack | تطوير الويب المتكامل (Full-Stack)",
    description: "وظّف مطوري MERN Stack لتطبيقات الويب الديناميكية والشاملة. اعمل مع خبراء ماهرين يتقنون MongoDB، و Express.js، و React.js، و Node.js. ابدأ الآن!",
  },

  // محتوى البانر الرئيسي
  mainBanner: {
    backgroundImage: `url(/images/hire-page-images/hire-mern.avif)`,
    image: "", // يمكن إزالته إذا لم يكن مطلوبًا بشكل صريح
    mainHeading: "وظّف مطوري MERN Stack",
    content: "أنشئ تطبيقات ويب قابلة للتوسع وعالية الأداء مع مطوري MERN Stack الخبراء لدينا. سواء كنت شركة ناشئة أو مؤسسة كبيرة، نحن نقدم خدمات تطوير عالية المستوى مصممة خصيصًا لاحتياجاتك.",
    btnText: "استشر مطوري MERN Stack لدينا",
    bannerList: [
      { list: "متعاقدون مستقلون" },
      { list: "وظائف بدوام كامل" },
      { list: "فرق عالمية" },
    ],
  },

  // قسم خبرة مطوري MERN Stack
  MernExpertise: { // تم تغيير الاسم من HireMernstackServicesData للاتساق مع مثال Flutter السابق
    btnText: "حدد موعدًا لإجراء مكالمة اليوم",
    heading: "خبرة مطوري MERN Stack لدينا",
    description: "يتخصص مطورونا في MERN Stack في بناء تطبيقات ويب قابلة للتوسع وعالية الأداء باستخدام MongoDB، و Express.js، و React.js، و Node.js. نضمن تكاملاً سلساً عبر حزمة التقنيات بأكملها لوظائف سلسة.",
    servicesData: [
      {
        title: "استشارات MERN Stack",
        description: "احصل على إرشادات الخبراء لمشروع MERN Stack الخاص بك، من تخطيط البنية إلى تحسين الأداء للحصول على أفضل نتائج التطوير.",
        icon: "/images/hire-page-icons/mern-stack-icon-1.svg",
      },
      {
        title: "تطوير الويب باستخدام MERN Stack",
        description: "نقوم ببناء تطبيقات ويب ديناميكية وغنية بالميزات تستفيد من القوة الكاملة لحزمة MERN، مما يضمن السرعة المثلى وقابلية التوسع.",
        icon: "/images/hire-page-icons/mern-stack-icon-2.svg",
      },
      {
        title: "تطوير واجهات برمجة التطبيقات (API) باستخدام MERN Stack",
        description: "يقوم فريقنا بتطوير واجهات برمجة تطبيقات آمنة وعالية الأداء تسهل التواصل السلس بين التطبيقات والخدمات المختلفة.",
        icon: "/images/hire-page-icons/mern-stack-icon-3.svg",
      },
      {
        title: "تطوير أنظمة إدارة المحتوى (CMS) والبوابات باستخدام MERN Stack",
        description: "قم بتطوير نظام إدارة محتوى مخصص (CMS) أو بوابة ويب باستخدام حزمة MERN لإدارة محتوى مرنة وتفاعلات مستخدم سلسة.",
        icon: "/images/hire-page-icons/mern-stack-icon-4.svg",
      },
      {
        title: "الترحيل إلى MERN Stack",
        description: "انقل تطبيقاتك الحالية بسلاسة إلى MERN Stack بدون فقدان للبيانات وأداء محسن.",
        icon: "/images/hire-page-icons/mern-stack-icon-5.svg",
      },
      {
        title: "التكامل مع الحلول الموجودة",
        description: "نحن نضمن التكامل السلس لتطبيق MERN Stack الخاص بك مع خدمات وأدوات ومنصات الجهات الخارجية لوظائف محسّنة.",
        icon: "/images/hire-page-icons/mern-stack-icon-6.svg",
      },
      {
        title: "حلول التجارة الإلكترونية باستخدام MERN Stack",
        description: "أنشئ منصات تجارة إلكترونية سريعة وقابلة للتوسع وجذابة تعزز تجربة المستخدم وتزيد التحويلات.",
        icon: "/images/hire-page-icons/mern-stack-icon-7.svg",
      },
      {
        title: "دعم وصيانة MERN Stack",
        description: "ضمان الاستقرار والأداء على المدى الطويل من خلال دعمنا المستمر، استكشاف الأخطاء وإصلاحها، وتحديثات النظام.",
        icon: "/images/hire-page-icons/mern-stack-icon-8.svg",
      },
    ],
  },

  // لماذا تختارنا (أداء التطوير)
  whyChooseUs: {
    btnText: "توظيف مطور اليوم",
    heading: "لماذا تختار Bitsclan لتوظيف ",
    greenHeading: "مطورين MERN؟",
    subHeading: "في Bitsclan، نبني تطبيقات ويب عالية الأداء وقابلة للتوسع باستخدام حزمة MERN (MongoDB، Express.js، React.js، Node.js). من خلال دمج تقنيات الواجهة الأمامية والجوّال الحديثة، ننشئ حلولاً مخصصة تتوافق مع أهداف عملك. سواء كنت تقوم بتطوير منصة ويب أو حل للجوّال، فإننا نضمن تطويراً سريعاً، وأداءً سلساً، وتجربة مستخدم متميزة عبر جميع الأجهزة.",
    solutionsData: [
      {
        icon: "/images/hire-page-icons/chose-ror-section1.svg",
        title: "الوصول إلى المواهب المعتمدة",
        description: "نحن نوصلك بمطوري MERN Stack ذوي المهارات العالية والخبرة، الذين يتقنون اللغة الإنجليزية، ولديهم كفاءة في تطوير JavaScript الشامل، مما يضمن التواصل والتنفيذ السلس.",
      },
      {
        icon: "/images/hire-page-icons/chose-ror-section2.svg",
        title: "اعثر على التطابق الصحيح على الفور",
        description: "تجاوز عناء فرز السير الذاتية التي لا نهاية لها. مع HireAI، يمكنك الوصول فوراً إلى أفضل مطوري MERN، مما يجعل عملية التوظيف أسرع وأكثر كفاءة.",
      },
      {
        icon: "/images/hire-page-icons/chose-ror-section3.svg",
        title: "وفّر مع التوظيف العالمي",
        description: "وسّع نطاق وصولك إلى ما وراء المواهب المحلية وقم بتوظيف أفضل مطوري MERN في جميع أنحاء العالم – مما يقلل تكاليف التوظيف بنسبة تصل إلى 58% مقارنة بالطرق التقليدية.",
        noBorder: true,
      },
      {
        icon: "/images/hire-page-icons/chose-ror-section4.svg",
        title: "احصل على دعم بشري حقيقي",
        description: "فريق التوظيف الخبير لدينا متاح في كل خطوة على الطريق، مما يضمن لك توظيف أفضل مطوري MERN Stack بثقة.",
      },
    ],
  },

  // تركيبات التقنيات
  techCombinations: {
    heading: "أفضل تركيبات MERN Stack لتطوير استثنائي",
    description: "استفد من قوة MERN Stack لبناء تطبيقات ويب ديناميكية، قابلة للتوسع، وعالية الأداء. وظّف مطوري MERN خبراء لإنشاء حلول سلسة وشاملة مصممة خصيصًا لاحتياجات عملك.",
    combinations: [
      {
        title: "MERN (MongoDB + Express.js + React + Node.js)",
        description: "MERN هو إطار عمل JavaScript شامل وقوي حيث تعمل MongoDB كقاعدة بيانات NoSQL، ويعالج Express.js منطق الواجهة الخلفية، ويبني React واجهات مستخدم ديناميكية، ويدير Node.js الخادم، مما يجعله مثالياً لتطبيقات الويب الحديثة.",
        icons: ["mongodb.svg", "express.svg", "react.svg", "nodejs.svg"],
      },
      {
        title: "MERN + GraphQL",
        description: "تُمكّن GraphQL استعلامات البيانات الفعالة، ويوفر React واجهة أمامية ديناميكية، ويضمن Express.js مع Node.js عمليات واجهة خلفية قابلة للتوسع بينما تخزن MongoDB بيانات NoSQL مرنة.",
        icons: ["mongodb.svg", "express.svg", "react.svg", "nodejs.svg", "graphql.svg"],
      },
      {
        title: "MERN + Redux Toolkit",
        description: "يعزز Redux Toolkit إدارة الحالة، بالاقتران مع حزمة MERN، مما يوفر تدفقاً سلساً للبيانات وقابلية توسع محسّنة للتطبيقات واسعة النطاق.",
        icons: ["mongodb.svg", "express.svg", "react.svg", "nodejs.svg", "redux.svg"],
      },
      {
        title: "MERN + Next.js",
        description: "يعمل Next.js على تحسين تحسين محركات البحث والأداء من خلال العرض من جانب الخادم (SSR)، مقترناً بحزمة MERN لبناء تطبيقات سريعة وقابلة للتوسع ومحسّنة لمحركات البحث.",
        icons: ["mongodb.svg", "express.svg", "react.svg", "nodejs.svg", "next-js.svg"],
      },
    ],
  },

  // خطوات التوظيف
  hireSteps: {
    btnText: "دعنا نجد المطور المثالي لك",
    heading: "وظّف مطوري MERN Stack في 4 خطوات سهلة",
    subHeading: "العثور على مطور MERN Stack المناسب أمر بسيط من خلال عمليتنا المبسطة المكونة من 4 خطوات. نحن نضمن التكامل السلس، والإعداد السريع، والتوافق المثالي لمشروعك.",
    steps: [
      {
        title: "اختر نموذج التعاقد الخاص بك",
        description: "حدد نموذجًا يناسب مشروعك - دوام كامل، أو دوام جزئي، أو بالساعة - لتحقيق أقصى قدر من المرونة والكفاءة.",
        icon: "/images/hire-page-setps-icons/icon-1.svg",
      },
      {
        title: "فحص واختيار مطوري MERN Stack",
        description: "استكشف ملفات تعريف أفضل مطوري MERN، قم بوضع قائمة مختصرة للمرشحين، واعثر على التطابق الصحيح لفريقك.",
        icon: "/images/hire-page-setps-icons/icon-2.svg",
      },
      {
        title: "إجراء مقابلة فردية",
        description: "قيم الخبرة الفنية من خلال الأسئلة العملية والنظرية للتأكد من تلبية احتياجات مشروعك.",
        icon: "/images/hire-page-setps-icons/icon-3.svg",
      },
      {
        title: "إعداد مطور MERN Stack الخاص بك",
        description: "بمجرد الاختيار، ينضم مطورك إلى فريقك في غضون 24-48 ساعة، ويكون جاهزًا لبدء العمل.",
        icon: "/images/hire-page-setps-icons/icon-4.svg",
      },
    ],
  },

  // تغطية الحزمة التقنية
  coverTheStack: {
    whereStart: "الواجهة الأمامية",
    mainHeading: "وظّف مطوري MERN Stack خبراء لحلول الويب الشاملة",
    subHeading: "في Bitsclan، ندعم رحلة تطوير الويب الخاصة بك بحزمة MERN متطورة، مما يضمن تطبيقات سلسة وقابلة للتوسع وعالية الأداء. يتخصص مطورونا الخبراء في بناء حلول ويب ديناميكية وشاملة باستخدام MongoDB و Express.js و React و Node.js لتلبية احتياجات عملك.",
    tabs: [
      "الواجهة الأمامية",
      "الواجهة الخلفية",
      "قاعدة البيانات",
    ],
    tabItems: [
      {
        "tab": "الواجهة الأمامية",
        "name": "ReactJS",
        "icon": "/images/iconthree.png"
      },
      {
        "tab": "الواجهة الأمامية",
        "name": "Vue.js",
        "icon": "/images/icon4.png"
      },
      {
        "tab": "الواجهة الخلفية",
        "name": "Express.js",
        "icon": "/images/database5.png"
      },
      {
        "tab": "الواجهة الخلفية",
        "name": "Laravel",
        "icon": "/images/tech-stack-icons/laravel.svg"
      },
      {
        "tab": "الواجهة الخلفية",
        "name": "Node.js",
        "icon": "/images/database9.png"
      },
      {
        "tab": "قاعدة البيانات",
        "name": "MongoDB",
        "icon": "/images/db3.png"
      }
    ]
  },

  // حقائق الخبراء
  expertFacts: {
    btnText: "حجز موعد",
    heading: "حقائق سريعة عن ",
    greenHeading: "فريق MERN Stack لدينا",
    facts: [
      { text: "<strong>أكثر من 10 مطوري MERN ماهرين: </strong>يقوم فريقنا الخبير من مطوري MERN ببناء تطبيقات ويب قوية وقابلة للتوسع مصممة خصيصًا لاحتياجاتك." },
      { text: "<strong>أكثر من 25 عامًا من الخبرة المشتركة:</strong> مع أكثر من 25 عامًا من الخبرة المشتركة، يجلب فريقنا معرفة عميقة في تطوير MERN الشامل." },
      { text: "<strong>إتقان تطوير الواجهة الشاملة:</strong> نحن متخصصون في React.js للواجهة الأمامية، و Node.js و Express.js للواجهة الخلفية، و MongoDB لحلول قواعد بيانات قوية." },
      { text: "<strong>حلول سحابية و بدون خادم:</strong> تضمن خبرتنا في البنى السحابية و بدون خادم تطبيقات قابلة للتوسع ومقاومة للمستقبل." },
      { text: "<strong> ممارسات DevOps و CI/CD قوية:</strong> من خلال ثقافة DevOps ناضجة، نقوم بتبسيط سير العمل لعمليات نشر أسرع وأكثر موثوقية." },
      { text: "<strong>خبراء في تطبيقات الويب عالية الأداء:</strong> نحن نبني تطبيقات ويب قابلة للتوسع وتعتمد على البيانات ومحسّنة للسرعة والكفاءة وتجارب المستخدم السلسة." },
    ],
    backgroundImage: `url(/images/hire-page-images/hire-mern-arabic.avif)`, // تم التغيير من factBackgroundImage
  },

  // قسم فكرة التطبيق
  appIdeaSection: {
    heading: "حوّل فكرتك لتطبيق إلى نموذج أولي عامل في أسابيع قليلة فقط!",
    content: "هل لديك فكرة رائعة ولكنك غير متأكد من كيفية تحقيقها؟ سيساعدك مطورو Ruby on Rails الخبراء لدينا على بناء نموذج أولي وظيفي في أقل من 6-8 أسابيع. تحقق من رؤيتك، واختبر تفاعل المستخدم، ووضع الأساس لإطلاق ناجح - بسرعة وكفاءة.",
  },

  // نماذج التعاقد (موجودة بالفعل)
  hirePageEngagementModels: {
    btnText: "ابدأ الآن",
    headingContent: [
      { text: "نماذجنا" },
      { text: "المرنة للتعاقد" },
    ],
    discription: "اختر نموذج التعاقد الذي يناسب احتياجات مشروعك! سواء كنت بحاجة إلى مطورين بدوام كامل أو جزئي أو بالساعة، نحن نقدم خيارات مرنة لضمان التعاون السلس وأقصى قدر من الكفاءة طوال مشروعك.",
    hiringDetails: [
      {
        text: "توظيف بالساعة",
        hours: "48",
        timeUnit: "ساعة",
        icon: "time.svg",
        bgColor: "#FDFDFF",
        durationLabel: "المدة",
        duration: "8 ساعات/يوم",
        minimumDaysLabel: "الحد الأدنى للأيام",
        minimumDays: "30 يومًا",
        billingLabel: "الفوترة",
        billing: "شهريًا",
        startWorkPhrase: "ابدأ العمل في غضون "
      },
      {
        text: "توظيف بدوام كامل",
        hours: "72",
        timeUnit: "ساعة",
        icon: "full-time.svg",
        bgColor: "#FFFEFA",
        durationLabel: "المدة",
        duration: "8 ساعات/يوم",
        minimumDaysLabel: "الحد الأدنى للأيام",
        minimumDays: "30 يومًا",
        billingLabel: "الفوترة",
        billing: "شهريًا",
        startWorkPhrase: "ابدأ في غضون "
      },
      {
        text: "توظيف بدوام جزئي",
        hours: "48",
        timeUnit: "ساعة",
        icon: "part-time.svg",
        bgColor: "#FDFFFA",
        durationLabel: "المدة",
        duration: "8 ساعات/يوم",
        minimumDaysLabel: "الحد الأدنى للأيام",
        minimumDays: "30 يومًا",
        billingLabel: "الفوترة",
        billing: "شهريًا",
        startWorkPhrase: "انطلق في غضون "
      },
    ],
  },

  // قسم الأسئلة الشائعة
  faqSection: {
    mainHeading: "الأسئلة الشائعة",
    subHeading: "اكتشف إجابات لأسئلة شائعة حول تطوير MERN Stack.",
    faqData: [
      {
        id: "collapseOne",
        question: "ما هو MERN Stack؟",
        answer: "MERN Stack هو مجموعة من التقنيات المستخدمة لبناء تطبيقات الويب. ويشمل MongoDB (قاعدة بيانات NoSQL)، و Express.js (إطار عمل ويب)، و React.js (مكتبة واجهة أمامية)، و Node.js (بيئة تشغيل من جانب الخادم). تعمل هذه الأدوات معًا لإنشاء تطبيقات ويب سريعة وقابلة للتوسع وديناميكية. عندما توظّف مطور MERN Stack، فإنك تحصل على شخص يمكنه التعامل مع عملية التطوير بأكملها من الواجهة الأمامية إلى الواجهة الخلفية.",
      },
      {
        id: "collapseTwo",
        question: "لماذا يجب علي توظيف مطور MERN Stack لمشروعي؟",
        answer: "يُعد توظيف مطور MERN Stack خيارًا رائعًا إذا كنت تبحث عن شخص يمكنه بناء تطبيقات ويب كاملة. يمكن لمطوري MERN العمل عبر جميع طبقات التطوير، مما يعني أنهم يستطيعون تصميم كل من الواجهة الأمامية والخلفية لتطبيقك، ودمج واجهات برمجة التطبيقات، وإدارة قواعد البيانات - كل ذلك ضمن حزمة تقنية موحدة. وهذا يجعل التطوير أسرع وأكثر كفاءة لأن كل شيء يعمل بسلاسة معًا.",
      },
      {
        id: "collapseThree",
        question: "ما هي أنواع المشاريع التي تناسب تطوير MERN Stack بشكل أفضل؟",
        answer: "MERN Stack مثالي لبناء تطبيقات الويب الحديثة مثل منصات التجارة الإلكترونية، ومواقع التواصل الاجتماعي، وتطبيقات الدردشة في الوقت الفعلي، وأنظمة إدارة المحتوى. إنه مفيد بشكل خاص لتطبيقات الصفحة الواحدة (SPAs) حيث يكون الأداء وتجربة المستخدم هما المفتاح. إذا كنت تهدف إلى إنشاء تطبيق ويب ديناميكي وتفاعلي بواجهة مستخدم سريعة الاستجابة، فإن MERN هو خيار قوي.",
      },
      {
        id: "fourth",
        question: "كم يستغرق تطوير تطبيق MERN Stack؟",
        answer: "يعتمد الوقت المستغرق لتطوير تطبيق MERN Stack على مدى تعقيد المشروع. قد يستغرق تطبيق بسيط بضعة أسابيع، بينما قد تستغرق منصة أكثر تعقيدًا بضعة أشهر. خلال الاستشارة الأولية، سيتمكن مطور MERN Stack الجيد من إعطائك جدولًا زمنيًا تقديريًا بناءً على متطلباتك وميزاتك.",
      },
      {
        id: "fifth",
        question: "هل أحتاج إلى معرفة البرمجة للعمل مع مطور MERN Stack؟",
        answer: "إطلاقاً! لا تحتاج إلى معرفة كيفية البرمجة للتعاون بفعالية مع مطور MERN Stack. المهم هو أن يكون لديك فهم واضح لأهداف مشروعك ووظائفه. سيقوم المطور الجيد بإرشادك خلال العملية، وشرح المصطلحات التقنية ببساطة، وإطلاعك على التقدم المحرز.",
      },
      {
        id: "sixth",
        question: "كم تبلغ تكلفة توظيف مطور MERN Stack؟",
        answer: "تختلف تكلفة توظيف مطور MERN Stack اعتمادًا على خبرته وموقعه ومدى تعقيد مشروعك. في المتوسط، يمكن أن تتراوح الأسعار بالساعة من 30 دولارًا إلى 150 دولارًا في الساعة. بالنسبة للمشاريع الكبيرة، قد يقدم بعض المطورين عرض أسعار ثابتًا. من الجيد دائمًا مناقشة ميزانيتك ومتطلبات المشروع مقدمًا لضمان عدم وجود مفاجآت لاحقًا.",
      },
    ],
  },
};